import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { API_BASE_URL } from '../config';
// Async thunk for submitting basic info

export const fetchStaffData = createAsyncThunk(
  "Staff/fetchStaffData",
  async (_, { rejectWithValue }) => {
         console.log("3 I am here");

    const storedUser = localStorage.getItem("userInfo");
         console.log("storedUser", storedUser);
   if (!storedUser) {
      return rejectWithValue("No user data found");
    }

    const { token } = JSON.parse(storedUser);
    const { userId } = JSON.parse(storedUser);
        console.log("userId", userId);
 
    if (!token ) {
      return rejectWithValue("Token or student IDs are missing");
    }

    try {
               console.log("4 I am here");

      const response = await axios.get(
        `${API_BASE_URL}/api/StaffProfile/account/${userId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
         console.log("5 I am here");

      console.log("response.data", response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

 

const staffDataSlice = createSlice({
  name: "staffData",
  initialState: {
    staffDetails: {},
    loading: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchStaffData.pending, (state) => {
        state.loading = "loading";
        state.error = null;
      })
      .addCase(fetchStaffData.fulfilled, (state, action) => {
        state.loading = "succeeded";
        state.staffDetails = action.payload;
 
      })
      .addCase(fetchStaffData.rejected, (state, action) => {
        console.error("Fetching failed:", action.error.message);
        state.loading = "failed";
        state.error = action.error.message;
      });
  },
});


// Export the reducer
export default staffDataSlice.reducer;